export default __webpack_public_path__ + "static/media/3-LazyNikau.84adceaf.jpeg";